import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WikiComponent } from './wiki.component';
import { WikiDetailsComponent } from './wiki-details.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: WikiComponent, children: [
      { path: ':path', loadChildren: () => import('./wiki-details.module').then(m => m.WikiDetailsModule)},
      ] },
    ])
  ],
  exports: [RouterModule]
})
export class WikiRoutingModule { }
